export default __webpack_public_path__ + "enterprise-boundaries-xray-480-878dd02dd3cfda71e05f6e2f2d8f812e.webp";